<div class="{{ classes() }}">
  <ngx-card
    [cardMode]="'bank'"
    [cardSize]="isMinimized() ? 'small' : 'default'"
    [loading]="isLoading()"
    [ownerName]="ownerName()"
    [expireDate]="expDate()"
    [cardNumber]="cardNumber()"
    [pinned]="isPinned()"
    [isTyping]="isSkeleton()"
    [width]="width()"
    [alias]="alias() ?? '' "
    [showOwnerLoading]="false"
  ></ngx-card>
</div>
